package one.healthium.pilates.presentation.navigation.today

import com.arkivanov.decompose.ComponentContext
import one.healthium.insights.domain.models.ActionModel

class DefaultTodayComponent(
    componentContext: ComponentContext,
    private val onActionClicked: (ActionModel) -> Unit,
) : TodayComponent, ComponentContext by componentContext {
    override fun onActionClicked(action: ActionModel) {
        onActionClicked.invoke(action)
    }
}
